import React from 'react';
import PageBase from '../components/PageBase';
import {Helmet} from "react-helmet";

const Materiala = () => {
  const styles = {
    images: {
      maxWidth: '100%'
    }
  };
  return (
    <PageBase title="Beharrezko materiala"
              navigation="Oñatiko Duatloi Txikia / Beharrezko Materiala">
        <Helmet>
          <title>Oñatiko Dutloi Txikia Materiala</title>
          <meta name="description" content="Oñatiko duatloi txikirako beharrezko materiala" />
          <meta property="og:title" content="Oñatiko Dutloi Txikia Materiala" />
          <meta property="og:description" content="Oñatiko duatloi txikirako beharrezko materiala" />
          <meta property="og:url" content="http://duatloitxikia.oinatikoduatloia.com/materiala" />
          <meta property="og:image" content="http://www.txantxiku.net/duatlon_onati/duatloi_txikia_2018/slides/IMG_2085.JPG" />
      </Helmet>
        <p>Parte hartu ahal izateko, ondorengo materialen beharra izango dute:</p>
        <ul>
          <li>Korrika egin eta bizikletan ibiltzeko kirol arropa aproposa:</li>
            <ul>
              <li>Frakak edo mailak: motzak edo luzeak eguraldiaren arabera.</li>
              <li>Kamista edo mailota: motza edo luzea eguraldiaren arabera.</li>
              <li>Zira: ez da beharrezkoa, eguraldiaren arabera.</li>
              <li>Korrika egiteko zapatila egokiak.</li>
            </ul>
          <li>Bizikleta</li>
          <li>Kaskoa</li>
        </ul>
        <p><center><img src="http://www.txantxiku.net/duatlon_onati/duatloi_txikia_2018/slides/IMG_2085.JPG" style={styles.images} /></center></p>
    </PageBase>
  );
};

export default Materiala;



/** WEBPACK FOOTER **
 ** ./src/containers/Materiala.js
 **/